/**
 * Format currency (Kenyan Shillings)
 * @param {number} amount - Amount to format
 * @returns {string} Formatted currency (e.g., "KSh 1,234.56")
 */
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return 'KSh 0';
  return `KSh ${amount.toLocaleString('en-KE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

/**
 * Format date to local date string
 * @param {string|Date} date - Date to format
 * @param {boolean} includeTime - Whether to include time
 * @returns {string} Formatted date
 */
export const formatDate = (date, includeTime = false) => {
  if (!date) return '-';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '-';
  const options = { year: 'numeric', month: 'short', day: '2-digit' };
  if (includeTime) {
    options.hour = '2-digit';
    options.minute = '2-digit';
  }
  return d.toLocaleDateString('en-KE', options);
};

/**
 * Format phone number (mask middle digits)
 * @param {string} phone - Phone number
 * @returns {string} Masked phone (e.g., 2547******78)
 */
export const formatPhone = (phone) => {
  if (!phone) return '-';
  const str = phone.toString();
  if (str.length <= 8) return str;
  return `${str.slice(0, 4)}****${str.slice(-2)}`;
};

/**
 * Format member ID (capitalize and trim)
 * @param {string} memberId - Member ID
 * @returns {string} Formatted member ID
 */
export const formatMemberId = (memberId) => {
  if (!memberId) return '-';
  return memberId.toUpperCase();
};

/**
 * Truncate text with ellipsis
 * @param {string} text - Text to truncate
 * @param {number} length - Max length
 * @returns {string} Truncated text
 */
export const truncate = (text, length = 50) => {
  if (!text) return '';
  if (text.length <= length) return text;
  return text.substring(0, length) + '...';
};

/**
 * Capitalize first letter of each word
 * @param {string} str - Input string
 * @returns {string} Capitalized string
 */
export const capitalizeWords = (str) => {
  if (!str) return '';
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};